module.exports = __webpack_public_path__ + "img/rename.d8f25a7c.svg";